import { useEffect, useState } from 'react';
import { AlertTriangle, X } from 'lucide-react';

export const OutreachSetup = ({ ids, templates, api, onStart, onClose }) => {
  const [tpl, setTpl] = useState('');
  const [prep, setPrep] = useState(null);

  useEffect(() => {
    setPrep(null);
    api('/prepare', { method: 'POST', body: JSON.stringify({ member_ids: ids, template_key: tpl || null }) }).then(setPrep);
  }, [ids, tpl, api]);

  const eligible = prep?.items.filter((x) => x.eligible) || [];
  const excluded = prep?.items.filter((x) => !x.eligible) || [];
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-testid="outreach-setup-dialog">
      <div className="absolute inset-0 bg-slate-900/40" onClick={onClose} />
      <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-2xl max-h-[90vh] overflow-y-auto p-6 space-y-4">
        <button type="button" onClick={onClose} className="absolute right-4 top-4 text-slate-400 hover:text-slate-700" data-testid="outreach-setup-close"><X className="w-5 h-5" /></button>
        <h3 className="font-outfit text-xl font-bold text-[#0b1f4d]">Prepare WhatsApp messages</h3>
        <label className="block text-sm">
          <span className="text-[11px] font-semibold uppercase tracking-wider text-slate-500">Message template</span>
          <select value={tpl} onChange={(e) => setTpl(e.target.value)} className="mt-1 w-full h-10 rounded-lg border border-slate-200 px-2.5" data-testid="outreach-template-select">
            <option value="">Automatic: best template for each student's status</option>
            {templates.map((t) => <option key={t.key} value={t.key}>{t.name}</option>)}
          </select>
        </label>
        {!prep ? <p className="text-sm text-slate-400">Preparing personalised messages…</p> : (<>
          <div className="flex flex-wrap gap-2 text-sm" data-testid="outreach-counts">
            <span className="rounded-full bg-slate-100 px-3 py-1">Selected: <b>{prep.items.length}</b></span>
            <span className="rounded-full bg-teal-100 text-teal-800 px-3 py-1">Eligible: <b data-testid="outreach-eligible-count">{prep.eligible}</b></span>
            <span className="rounded-full bg-rose-50 text-rose-700 px-3 py-1">Excluded: <b data-testid="outreach-excluded-count">{prep.excluded}</b></span>
            {eligible.some((x) => x.repeat_warning) && <span className="rounded-full bg-amber-100 text-amber-800 px-3 py-1 flex items-center gap-1"><AlertTriangle className="w-3.5 h-3.5" />{eligible.filter((x) => x.repeat_warning).length} contacted recently</span>}
          </div>
          {excluded.length > 0 && (
            <details className="text-xs text-slate-600 bg-rose-50/50 rounded-lg p-3" data-testid="outreach-excluded-list">
              <summary className="cursor-pointer font-semibold">Why {excluded.length} student(s) are excluded</summary>
              <ul className="mt-2 space-y-1">{excluded.map((x) => <li key={x.id}>{x.full_name}: {x.excluded_reason}</li>)}</ul>
            </details>
          )}
          <div className="space-y-2">
            <p className="text-[11px] font-semibold uppercase tracking-wider text-slate-500">Preview{eligible.length > 3 ? ' (first 3)' : ''}</p>
            {eligible.slice(0, 3).map((x) => (
              <div key={x.id} className="rounded-xl bg-[#e7fbe9] border border-green-100 p-3 text-sm" data-testid={`outreach-preview-${x.id}`}>
                <p className="text-[11px] font-semibold text-slate-500 mb-1">To {x.full_name} · +{x.phone_e164} · {x.template_name}</p>
                <p className="whitespace-pre-wrap [overflow-wrap:anywhere] text-slate-800">{x.message}</p>
              </div>
            ))}
          </div>
          <button type="button" disabled={!eligible.length} onClick={() => onStart(eligible)} data-testid="outreach-start-queue-btn"
            className="w-full rounded-full bg-[#0b1f4d] text-white font-semibold py-3 disabled:opacity-40">
            Start guided sending ({eligible.length})
          </button>
          <p className="text-xs text-slate-500 text-center">Nothing is sent automatically. You'll open each chat in WhatsApp and press send yourself.</p>
        </>)}
      </div>
    </div>
  );
};
